import script from "./SplashAnimate.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashAnimate.vue?vue&type=script&setup=true&lang=js"

import "./SplashAnimate.vue?vue&type=style&index=0&id=2cea594d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cea594d"]])

export default __exports__